export default __webpack_public_path__ + "static/ONT_logo_reverse-b8ad7c72fd3c66d4a7a88c6bc5e013fa.png";